(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgc-product"] && !Shopify.designMode) return;
  try {
    
function initPartyGamesProduct(root){
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 const strings=JSON.parse(root.querySelector('[data-pgc-strings]').textContent);
 const radios=[...root.querySelectorAll('input[name="quantity"]')];
 const add=root.querySelector('[data-add]');
 const format=new Intl.NumberFormat('en-AU',{style:'currency',currency:root.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2});
 const motionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
 const controller=new AbortController();
 const listen=(element,event,fn)=>element?.addEventListener(event,fn,{signal:controller.signal});
 let lastPack=null;
 function update(){
  const chosen=radios.find(r=>r.checked);
  if(!chosen)return;
  root.querySelector('[data-selected-price]').textContent=format.format(Number(chosen.dataset.total)/100);
  const count=Number(chosen.value);
  const remaining=Math.max(0,3-count);
  root.querySelector('[data-shipping-message]').textContent=remaining===0?strings.qualified:remaining===1?strings.moreOne:strings.moreMany.replaceAll('__COUNT__',remaining);
  root.querySelector('[data-shipping-progress]').value=Math.min(3,count);
  root.querySelector('[data-gift-message]').textContent=count===1?strings.giftOne:strings.giftMany.replaceAll('__COUNT__',count);
  const saving=Number(chosen.dataset.saving);
  root.querySelector('[data-saving-message]').textContent=saving>0?strings.saving.replace('__AMOUNT__',format.format(saving/100)):'';
  root.querySelectorAll('[data-select-pack]').forEach(button=>button.hidden=Number(button.dataset.selectPack)<=count);
  const nudge=root.querySelector('[data-three-nudge]');
  nudge.hidden=count>=3;
  if(count<3){const deliveredExtra=(strings.threeTotal-Number(chosen.dataset.total)-799)/100;root.querySelector('[data-upgrade-copy]').textContent=(count===1?strings.nudgeOne:strings.nudgeTwo).replace('__AMOUNT__',format.format(deliveredExtra));}
  const stickySummary=root.querySelector('[data-sticky-summary]');
  stickySummary.textContent=(count===1?strings.singleName:strings.packName.replace('__COUNT__',count))+' · '+format.format(Number(chosen.dataset.total)/100);
  root.querySelector('[data-sticky-shipping]').textContent=count>=3?strings.freeShipping:strings.paidShipping;
  if(lastPack!==count){root.querySelector('[data-gallery-kind="'+(count===3?'bundle_image':'hero_image')+'"]').click();lastPack=count;}
  const enough=chosen.dataset.stock==='true';
  add.disabled=!(strings.available&&enough);
  root.querySelector('[data-add-label]').textContent=!strings.available?strings.soon:enough?(count===1?strings.add:strings.addMany.replace('__COUNT__',count)):strings.stock;
  const stickyAdd=root.querySelector('[data-sticky-add]');stickyAdd.disabled=add.disabled;stickyAdd.textContent=root.querySelector('[data-add-label]').textContent;
 }
 radios.forEach(r=>listen(r,'change',update));
 root.querySelectorAll('[data-select-pack]').forEach(button=>listen(button,'click',()=>{radios.find(r=>r.value===button.dataset.selectPack).checked=true;update();}));
 listen(window,'pageshow',update);
 root.querySelectorAll('[data-select-three]').forEach(a=>listen(a,'click',()=>{radios.find(r=>r.value==='3').checked=true;update();}));
 listen(root.querySelector('[data-pgc-form]'),'submit',e=>{if(add.disabled){e.preventDefault();return;}if(window.PgcCart&&typeof document.querySelector('[data-pgc-drawer]')?.showModal==='function'){e.preventDefault();window.PgcCart.add(e.currentTarget,e.submitter||add);}else{add.disabled=true;}});

 root.querySelectorAll('[data-gallery-thumb]').forEach(button=>listen(button,'click',()=>{
  const image=root.querySelector('[data-gallery-main]');
  image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.alt||'';
  root.querySelectorAll('[data-gallery-thumb]').forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
 }));
 const pause=root.querySelector('[data-motion]');
 let observer;
 function showAll(){root.querySelectorAll('.pgc-reveal-wait').forEach(el=>el.classList.remove('pgc-reveal-wait'));if(observer)observer.disconnect();}
 listen(pause,'click',()=>{
  const paused=root.classList.toggle('is-motion-paused');
  pause.setAttribute('aria-pressed',String(paused));
  pause.textContent=paused?'▶':'Ⅱ';
  if(paused)showAll();
 });
 if(!motionPreference.matches&&'IntersectionObserver' in window&&!window.Shopify?.designMode){
  observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('pgc-reveal-wait');observer.unobserve(entry.target);}}),{threshold:.08});
  root.querySelectorAll('[data-reveal]').forEach(el=>{if(el.getBoundingClientRect().top>window.innerHeight){el.classList.add('pgc-reveal-wait');observer.observe(el);}});
 }
 listen(motionPreference,'change',()=>{if(motionPreference.matches)showAll();});
 const stickyObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{root.querySelector('[data-product-sticky]').hidden=entries[0].isIntersecting;},{threshold:0}):null;
 stickyObserver?.observe(root.querySelector('[data-pgc-form]'));
 listen(document,'shopify:section:unload',e=>{if(e.target.contains(root)){controller.abort();stickyObserver?.disconnect();if(observer)observer.disconnect();}});
 update();
}
document.querySelectorAll('[data-pgc-product]').forEach(initPartyGamesProduct);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pgc-product]').forEach(initPartyGamesProduct));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pgc-sales"] && !Shopify.designMode) return;
  try {
    
function initPartyGamesV2(root){
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 const strings=JSON.parse(root.querySelector('[data-pgc-strings]').textContent);
 const radios=[...root.querySelectorAll('input[name="quantity"]')];
 const add=root.querySelector('[data-add]');
 const format=new Intl.NumberFormat('en-AU',{style:'currency',currency:root.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2});
 const motionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
 const controller=new AbortController();
 const listen=(element,event,fn)=>element?.addEventListener(event,fn,{signal:controller.signal});
 let lastPack=null;
 function update(){
  const chosen=radios.find(r=>r.checked);
  if(!chosen)return;
  root.querySelector('[data-selected-price]').textContent=format.format(Number(chosen.dataset.total)/100);
  const count=Number(chosen.value);
  const remaining=Math.max(0,3-count);
  root.querySelector('[data-shipping-message]').textContent=remaining===0?strings.qualified:remaining===1?strings.moreOne:strings.moreMany.replaceAll('__COUNT__',remaining);
  root.querySelector('[data-shipping-progress]').value=Math.min(3,count);
  root.querySelector('[data-gift-message]').textContent=count===1?strings.giftOne:strings.giftMany.replaceAll('__COUNT__',count);
  const saving=Number(chosen.dataset.saving);
  root.querySelector('[data-saving-message]').textContent=saving>0?strings.saving.replace('__AMOUNT__',format.format(saving/100)):'';
  root.querySelectorAll('[data-select-pack]').forEach(button=>button.hidden=Number(button.dataset.selectPack)<=count);
  const nudge=root.querySelector('[data-three-nudge]');
  nudge.hidden=count>=3;
  if(count<3){const deliveredExtra=(strings.threeTotal-Number(chosen.dataset.total)-799)/100;root.querySelector('[data-upgrade-copy]').textContent=(count===1?strings.nudgeOne:strings.nudgeTwo).replace('__AMOUNT__',format.format(deliveredExtra));}
  if(lastPack!==count){root.querySelector('[data-gallery-kind="'+(count===3?'bundle_image':'hero_image')+'"]').click();lastPack=count;}
  const enough=chosen.dataset.stock==='true';
  add.disabled=!(strings.available&&enough);
  root.querySelector('[data-add-label]').textContent=!strings.available?strings.soon:enough?(count===1?strings.add:strings.addMany.replace('__COUNT__',count)):strings.stock;
 }
 radios.forEach(r=>listen(r,'change',update));
 root.querySelectorAll('[data-select-pack]').forEach(button=>listen(button,'click',()=>{radios.find(r=>r.value===button.dataset.selectPack).checked=true;update();}));
 listen(window,'pageshow',update);
 root.querySelectorAll('[data-select-three]').forEach(a=>listen(a,'click',()=>{radios.find(r=>r.value==='3').checked=true;update();}));
 listen(root.querySelector('[data-pgc-form]'),'submit',e=>{if(add.disabled){e.preventDefault();return;}if(window.PgcCart&&typeof document.querySelector('[data-pgc-drawer]')?.showModal==='function'){e.preventDefault();window.PgcCart.add(e.currentTarget,e.submitter||add);}else{add.disabled=true;}});

 root.querySelectorAll('[data-gallery-thumb]').forEach(button=>listen(button,'click',()=>{
  const image=root.querySelector('[data-gallery-main]');
  image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.alt||'';
  root.querySelectorAll('[data-gallery-thumb]').forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
 }));
 const pause=root.querySelector('[data-motion]');
 let observer;
 function showAll(){root.querySelectorAll('.pgc-reveal-wait').forEach(el=>el.classList.remove('pgc-reveal-wait'));if(observer)observer.disconnect();}
 listen(pause,'click',()=>{
  const paused=root.classList.toggle('is-motion-paused');
  pause.setAttribute('aria-pressed',String(paused));
  pause.textContent=paused?'▶':'Ⅱ';
  if(paused)showAll();
 });
 if(!motionPreference.matches&&'IntersectionObserver' in window&&!window.Shopify?.designMode){
  observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('pgc-reveal-wait');observer.unobserve(entry.target);}}),{threshold:.08});
  root.querySelectorAll('[data-reveal]').forEach(el=>{if(el.getBoundingClientRect().top>window.innerHeight){el.classList.add('pgc-reveal-wait');observer.observe(el);}});
 }
 listen(motionPreference,'change',()=>{if(motionPreference.matches)showAll();});
 listen(document,'shopify:section:unload',e=>{if(e.target.contains(root)){controller.abort();if(observer)observer.disconnect();}});
 update();
}
document.querySelectorAll('[data-pgc]').forEach(initPartyGamesV2);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pgc]').forEach(initPartyGamesV2));


  } catch(e) { console.error(e); }
})();
})();
